// @flow
import * as React from 'react';
import Box from 'sail/Box';
import classNames from 'classnames';
import {CopyButton} from './CopyButton';
import './Command.scss';

type CommandProps = {|
  text: string,
|};

export const Command = ({text}: CommandProps) => {
  const lines = text.split('\\n');

  return (
    <Box
      className={classNames(
        'Command',
        lines.length > 1 ? 'Command--multiline' : 'Command--singleline',
      )}
      divider={{color: 'light', width: 1, side: 'all'}}
      flex={{justifyContent: 'space-between', alignItems: 'center'}}
    >
      <code>{lines.join('\n')}</code>
      <CopyButton text={lines.join('')} />
    </Box>
  );
};
